module.exports = __webpack_public_path__ + "assets/img/icon1.2ca92bb9.svg";